import { render } from "./ZeroTouchIcon.vue?vue&type=template&id=2292dde4"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ZeroTouchIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2292dde4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2292dde4', __exports__)) {
    api.reload('2292dde4', __exports__)
  }
  
  module.hot.accept("./ZeroTouchIcon.vue?vue&type=template&id=2292dde4", () => {
    api.rerender('2292dde4', render)
  })

}


export default __exports__